import { payslipStatusLabel, payslipStatusView, type PayslipStatusTone } from './payslipStatus';

function StatusIcon({ tone }: { tone: PayslipStatusTone }) {
  const common = { width: 12, height: 12, viewBox: '0 0 16 16', 'aria-hidden': true, focusable: false } as const;
  switch (tone) {
    case 'paid': // check
      return <svg {...common}><path d="M3 8.5l3.2 3.2L13 5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    case 'approved': // ringed check
      return <svg {...common}><circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeWidth="1.6" /><path d="M5.2 8.2l2 2 3.6-3.8" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    case 'processing': // clock
      return <svg {...common}><circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeWidth="1.6" /><path d="M8 4.6V8l2.4 1.4" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>;
    case 'voided': // ban
      return <svg {...common}><circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeWidth="1.6" /><path d="M4 12L12 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>;
    default: // question mark
      return <svg {...common}><circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeWidth="1.6" /><path d="M6.4 6.3a1.7 1.7 0 1 1 2.4 1.5c-.5.3-.8.6-.8 1.2M8 11.4v.1" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>;
  }
}

/** Status chip: icon + text + colour. `variant="statement"` shows Voided in red (the document badge in the
 * Figma); the list keeps Voided in the neutral grey the list design uses. A simulated Paid reads "Paid (simulated)". */
export function PayslipStatusBadge({ status, simulated = false, variant = 'list' }: { status: string; simulated?: boolean; variant?: 'list' | 'statement' }) {
  const view = payslipStatusView(status);
  return (
    <span className={`badge payslip-status payslip-status--${view.tone} payslip-status--${variant}`} data-status={view.status ?? 'unknown'}>
      <StatusIcon tone={view.tone} />
      {payslipStatusLabel(status, simulated)}
    </span>
  );
}
